import {
  LOCALE,
  SUPPORTED_LOCALE,
  type COUNTRY_CODE
} from "@kivunova/kivufrontendcommon";

/**
 * Reads REACT_APP_IREMBOPAY_* from .env.local or .env (see webpack.config.cjs → DefinePlugin).
 * {@link useIremboSubscriptionPaymentFlow} requires this to be true before payment / invoice steps.
 */
export const isIremboMembershipCheckoutEnabled = (): boolean =>
  process.env.REACT_APP_IREMBOPAY_ENABLED === "true";

/**
 * IremboPay public key (safe in the browser) for the JS widget `IremboPay.initiate`.
 */
export const getIremboPublicKey = (): string =>
  process.env.REACT_APP_IREMBOPAY_PUBLIC_KEY?.trim() ?? "";

/**
 * Resolves app / i18n language strings to a supported {@link LOCALE} for routing and widgets.
 */
export function uiLocaleFromCandidates(
  ...candidates: (string | LOCALE | undefined | null)[]
): LOCALE {
  for (const c of candidates) {
    if (c == null) continue;
    const trimmed = String(c).trim();
    if (!trimmed) continue;
    const primary = trimmed.split("-")[0].toLowerCase();
    const found = SUPPORTED_LOCALE.find((l) => l === primary);
    if (found) {
      return found;
    }
  }
  return LOCALE.EN;
}

export function iremboLanguageFromUi(
  lang: string | LOCALE | undefined
): string {
  const normalized = String(lang ?? LOCALE.EN).trim();
  if (!normalized) return "EN";
  const primary = normalized.split("-")[0].toUpperCase();
  if (primary === "SW") return "EN";
  return primary;
}

export function buildIremboAccountIdentifier(
  country: COUNTRY_CODE,
  nationalNumber: string,
  phoneMap: Record<string, { code: string }>
): string {
  const entry = phoneMap[country];
  const cc = (entry?.code ?? "").replace(/\D/g, "");
  const n = nationalNumber.replace(/\D/g, "");
  return `${cc}${n}`;
}
